// Display helpers shared across analytics tabs.

export const fmtNum = (n: number | undefined | null): string => {
  if (n === undefined || n === null || Number.isNaN(n)) return '—';
  return Math.round(n).toLocaleString('en-IN');
};

export const fmtPct = (rate: number | undefined | null): string => {
  if (rate === undefined || rate === null || Number.isNaN(rate)) return '—';
  return `${(rate * 100).toFixed(0)}%`;
};

// Seconds -> "1h 05m" / "12m 30s" / "45s".
export const fmtDuration = (seconds: number | undefined | null): string => {
  if (seconds === undefined || seconds === null || Number.isNaN(seconds)) return '—';
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(sec).padStart(2, '0')}s`;
  return `${sec}s`;
};

// Format a UTC/ISO timestamp as an IST date-time, e.g. "31 May 2026, 04:30 AM".
// The DB stores UTC; the admin UI always previews in IST (Asia/Kolkata).
export const fmtDateTimeIST = (iso: string | Date | undefined | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const CHART_COLORS = ['#1976d2', '#26a69a', '#ef6c00', '#8e24aa', '#c2185b', '#00897b', '#5e35b1'];
